module.exports = __webpack_public_path__ + "img/CB1-Off-11.86227000.gif";